import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { PPUIPageHeader } from 'pricing-pages-ui-components/semantic/PageHeader';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { useEffect } from 'react';
import * as ProductLines from 'self-service-api/constants/ProductLines';
import { BUNDLE } from 'self-service-api/constants/UpgradeProducts';
import PhoneSupport from '../components/common/PhoneSupport';
import ProductPageSubtitle from '../components/common/ProductPageSubtitle';
import ProductPageTitle from '../components/common/ProductPageTitle';
import MobileWrapper from '../components/mobile/containers/MobileWrapper';
import AddonsPickerList from '../components/plan-builder/AddonsPickerList';
import HubPlanPickerListContainer from '../components/plan-builder/HubPlanPickerList/HubPlanPickerListContainer';
import PlanBuilderContainer from '../components/plan-builder/PlanBuilderContainer';
import SummaryColumn from '../components/plan-builder/SummaryColumn';
import { NavItemEnum } from '../constants/routing/NavItems';
import { SCREENS } from '../constants/tracking/Screens';
import { CREATE_A_BUNDLE } from '../constants/tracking/TrackingSources';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import { trackPageView } from '../utils/tracking/trackingEventUtils';
import { useQueryParamTerm, useQueryParamsEffect } from '../utils/urls/appQueryParamUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const MobileBundlePage = () => {
  useDocumentTitle('bundle');
  useEffect(() => {
    getUsageTracker().setProperties({
      screen: SCREENS.BUNDLE,
      trackingSource: CREATE_A_BUNDLE
    });
    trackPageView.withLastKnownEventProperties({});
    return () => {
      getUsageTracker().setProperties({
        trackingSource: undefined
      });
    };
  }, []);
  const {
    queryParamTerm
  } = useQueryParamTerm();
  useQueryParamsEffect({
    term: queryParamTerm
  });
  return /*#__PURE__*/_jsxs(MobileWrapper, {
    navMarkerName: 'BUNDLE_PAGE',
    navItem: NavItemEnum.BUNDLE,
    children: [/*#__PURE__*/_jsxs(PPUIPageHeader, {
      children: [/*#__PURE__*/_jsx(ProductPageTitle, {
        nonProductIdentifier: NavItemEnum.BUNDLE
      }), /*#__PURE__*/_jsx(ProductPageSubtitle, {
        nonProductIdentifier: NavItemEnum.BUNDLE
      })]
    }), /*#__PURE__*/_jsx(PlanBuilderContainer, {
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(HubPlanPickerListContainer, {
          productLines: ProductLines.AllProductLines
        }), /*#__PURE__*/_jsx(AddonsPickerList, {
          defaultOpen: true
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(SummaryColumn, {
            shareLinkAnchor: "",
            hubsSignupProductOverride: "bundle"
          }), /*#__PURE__*/_jsx(PageSection, {
            children: /*#__PURE__*/_jsx(PhoneSupport, {
              phoneSourceId: "bundle",
              showBorder: false,
              screen: SCREENS.BUNDLE,
              upgradeProduct: BUNDLE
            })
          })]
        })]
      })
    })]
  });
};
export default MobileBundlePage;